import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const ResendVerificationOtpResponseSchema = z.pipe(
  z.object({
    ...GeneralBackendResponseSchema,
    payload: z.optional(
      z.object({
        otpToken: z.string(),
      }),
    ),
  }),
  z.transform((data) => {
    return {
      message: data.message,
      otpToken: data.payload?.otpToken,
    };
  }),
);
